const rankings = [
  { rank: 1, title: '千万粉主播"XX"人设崩塌事件', heat: '42.3w', trend: 'up', change: '+15.2w', icon: 'ri-fire-line' },
  { rank: 2, title: '情感博主PUA操控多人被实锤', heat: '38.7w', trend: 'up', change: '+12.8w', icon: 'ri-fire-line' },
  { rank: 3, title: '舞蹈网红涉未成年人法律追责', heat: '35.1w', trend: 'up', change: '+28.4w', icon: 'ri-fire-line' },
  { rank: 4, title: '美妆博主代工厂成本大揭秘', heat: '31.6w', trend: 'up', change: '+9.3w', icon: 'ri-fire-line' },
  { rank: 5, title: 'MCN霸王合同条款全网热议', heat: '28.9w', trend: 'up', change: '+6.7w', icon: 'ri-fire-line' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热度榜单</h2>
            <p className="mt-2 text-sm text-foreground-500">实时更新的网红黑料热度排行榜，看看今天大家都在讨论什么</p>
          </div>

          <div className="max-w-2xl mx-auto space-y-3">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="group cursor-pointer flex items-center gap-4 p-4 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-primary-500/30 transition-all duration-300"
              >
                <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-heading text-lg ${
                  item.rank === 1
                    ? 'bg-primary-500/15 text-primary-500'
                    : item.rank === 2
                    ? 'bg-accent-500/15 text-accent-500'
                    : item.rank === 3
                    ? 'bg-secondary-500/15 text-secondary-500'
                    : 'bg-background-300/50 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors duration-200 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1 text-xs">
                    <span className="flex items-center gap-1 text-primary-500">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className={`${item.icon} text-xs`}></i>
                      </span>
                      {item.heat}
                    </span>
                    <span className="text-accent-500">{item.change}</span>
                  </div>
                </div>

                <div className="flex-shrink-0">
                  <span className="inline-flex items-center gap-1 text-xs text-accent-500 whitespace-nowrap">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-up-line"></i>
                    </span>
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}